import { extract } from 'yafrpl/objects';

// html common attributes
export default extract([
  /^aria-.+$/,
  'accesskey',
  'class',
  'contenteditable',
  'contextmenu',
  /^data-.+$/,
  'disabled',
  'dir',
  'draggable',
  'dropzone',
  'hidden',
  'id',
  'lang',
  'role',
  'spellcheck',
  'style',
  'tabIndex',
  'title',
  'translate',
  /^itemProp$/i,
  /^itemScope$/i,
  /^itemType$/i,
]);
